import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTruck01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.838 3H5.162c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C1 6.18 1 6.635 1 7.161V15c0 1.34.88 2.476 2.093 2.86a4.001 4.001 0 0 0 7.781.14h3.662a3.5 3.5 0 0 0 6.937-.06 1.76 1.76 0 0 0 .292-.092 2 2 0 0 0 1.083-1.082 2.03 2.03 0 0 0 .14-.65c.012-.175.012-.38.012-.59v-2.914c0-.19.001-.43-.055-.665-.05-.204-.13-.399-.24-.578a2.795 2.795 0 0 0-.43-.508l-.037-.037-4.062-4.062-.036-.036a2.795 2.795 0 0 0-.51-.431 2 2 0 0 0-.577-.24A2.795 2.795 0 0 0 16.388 6H14.982a6.737 6.737 0 0 0-.013-.195c-.032-.395-.103-.789-.296-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 10.838 3ZM21 15.696V12.663c0-.131 0-.196-.002-.244v-.004l-.003-.002a6.14 6.14 0 0 0-.17-.174l-4.063-4.063a6.175 6.175 0 0 0-.175-.17l-.002-.003h-.004A6.18 6.18 0 0 0 16.337 8H15v7.696A3.498 3.498 0 0 1 18 14c1.273 0 2.387.68 3 1.696ZM7 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm9.5 2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgTruck01.displayName = 'Truck01';
export default SvgTruck01;
